import { motion } from "framer-motion";

const categoryLabels = {
  finance: "Finance",
  time: "Temps dirigeant",
  digital: "Digitalisation",
  strategy: "Stratégie",
};

function getCategoryLabel(cat) {
  return categoryLabels[cat] || cat?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export default function DiagnosticProgress({ categories, currentIndex, answers, totalQuestions }) {
  const answeredCount = Object.keys(answers).length;
  const percent = totalQuestions > 0 ? Math.round((answeredCount / totalQuestions) * 100) : 0;

  return (
    <div data-testid="diagnostic-progress" className="mb-8">
      {/* Overall progress bar */}
      <div className="flex items-center justify-between mb-2">
        <span className="text-slate-400 text-sm">{answeredCount} / {totalQuestions} questions</span>
        <span className="text-[#59C3A6] text-sm font-semibold">{percent}%</span>
      </div>
      <div className="w-full h-2 bg-[#112A4F]/50 rounded-full overflow-hidden mb-6">
        <motion.div
          className="h-full bg-gradient-to-r from-[#59C3A6] to-[#4AB095] rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${percent}%` }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        />
      </div>

      {/* Category tabs */}
      <div className="flex gap-2 overflow-x-auto pb-2">
        {categories.map((cat, i) => (
          <button
            key={cat}
            data-testid={`progress-tab-${cat}`}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
              i === currentIndex
                ? "bg-[#59C3A6] text-[#0B1F3B]"
                : i < currentIndex
                ? "bg-[#59C3A6]/20 text-[#59C3A6]"
                : "bg-[#112A4F]/40 text-slate-500"
            }`}
            disabled
          >
            {getCategoryLabel(cat)}
          </button>
        ))}
      </div>
    </div>
  );
}
